<!-- <div class="alert alert-info">
    Username: test<br />
    Password: test
</div> -->

<!-- <div class="jumbotron">
    <div class="container">
            <h2>Login</h2>
        <div class="row col-md-6">
                
                <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                    <div class="form-group">
                        <label for="username">Username</label>
                        <input type="text" formControlName="username" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.username.errors }"
                        />
                        <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                            <div *ngIf="f.username.errors.required">Username is required</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="password">Password</label>
                        <input type="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }"
                        />
                        <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                            <div *ngIf="f.password.errors.required">Password is required</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <button [disabled]="loading" class="btn btn-primary">Login</button>
                        <img *ngIf="loading" class="pl-2" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="
                        />
                    </div>
                    <div *ngIf="error" class="alert alert-danger">{{error}}</div>
                </form>
        </div>
    </div>
</div> -->
<style>
.aff-login-form .forgot {
	display: inline-block;
	margin: 3vh 0;
	text-align: center;
	width: 100%;
	font-size: 16px;
	color: #808080;
	cursor: pointer;
}
.aff-login-form .forgot:hover {color: var(yellow);}
</style>


<div class="login_body">
    <div class="loginbody-content">

        <div class="container-fluid">
                <div class="col-md-12">
                    <div class="login-outer-box">
                        <div class="outer-box-content">
                            <div style="text-align: center;">
                                <img alt="Affinitv" src="assets/images/nextgen_data.png"style="
                                max-width: 160px;
                                margin: -15px auto -40px;
                                border-radius: 2px;">
                            </div>
                            <div class="text-center lheading">Affinitiv Data Management Technology (ADMT)</div>
                            <div class="lsub-heading">Solution for Dealer Management.</div>
                        </div>

                        <div class="login-box">
                                <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                                <div class="text-center">
                                    <img alt="Affinitv" src="assets/images/Affinitiv_Color_Logo_NEW.png" style="
                                    max-width: 200px;">
                                </div>
                                <br>
                                <div class="form-group">
                                    <input type="text" formControlName="username" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.username.errors }"/>
                                    <span class="error" id="emailError"></span>
                                </div>
                                <div class="form-group">
                                    <input type="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }"
                                    />
                                    <span class="error" id="pwdError"></span>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 text-right">
                                        <!-- <span class="form-signin-forgot-password" style="cursor:pointer;">Forgot Password?</span> -->
                                        <a _ngcontent-c1="" (click) = "ForgotPassword()" class="forgot" style="float: left;cursor:pointer;">Forgot your password?</a>
                                        <button name="loginBtn" class="btn btn-primary">
                                            Sign In
                                        </button>

                                    </div>

                                </div>
                                <div *ngIf="loginerrormsg" class="alert dark alert-alt alert-danger" role="alert" style="margin-top: 10px;">
										<span>
									  Please enter a valid</span>
										<strong> Username</strong> or<strong> Password </strong>
									</div>
                            </form>

                        </div>
                        <!-- login box ends -->
                    </div>
                </div>
            <!-- row ends -->
        </div>
       
    </div>
</div>

<p-dialog header="Forgot Password" [(visible)]="displayDialog" [responsive]="true" showEffect="fade"
            [modal]="true" width="300" height="200">
            <form [formGroup]="forgotPassword" novalidate class="form-horizontal">
                <div style="margin-bottom:30px;">
                    <ng-container>Username</ng-container><span class="field_req">*</span>
                    <input type="text" class="form-control" placeholder="Username (required)" name="Uname"
                        formControlName="Uname">
                    <span *ngIf="ForgotpasswordErMsg" style="color:red">Username not found.</span>
                    <span *ngIf="ForgotpasswordSuccessMsg" style="color:green">Check your email for reset
                        password.</span>
                </div>
                <div class="w-btn-right">
                    <button class="btn table-btn btn-radius btn-default" type="button" (click)="Cancel()"
                        style="color:#0072C6;">
                        <ng-container>Cancel </ng-container>
                    </button>
                    <button class="btn table-btn btn-radius btn-primary" type="button"
                        [disabled]='!forgotPassword.valid' (click)="Submit()">
                        <ng-container>Submit </ng-container>
                    </button>
                </div>
            </form>
        </p-dialog>
